import { Observable, timer, interval } from 'rxjs';

export class Mensaje {
    titulo: string = "";
    texto: string = "";
    mostrar:boolean = false;
    clase: string = "";
    cuentaAtras:number = 6;

    constructor(autodestruccion:boolean = false, cuentaAtras: number = 6){
        if(autodestruccion){
            this.iniciarCuentaAtras();
        }
        this.cuentaAtras = cuentaAtras;        
    }
    
    iniciarCuentaAtras = function(){
        timer(0, 7000).subscribe(x => {
            this.cuentaAtras -= 1;

            if (this.cuentaAtras < 0){
                this.cuentaAtras = 6;
                this.mostrar = false;
            }
        });
    }
}